module.exports = "/assets/data/1c4d4c8c56e24dc92f73818234d9dabe-BN12.data.json";